import gql from 'graphql-tag';

const UPDATE_EMAIL = gql`
  mutation updateEmail($email: String!) {
    changeEmail(email: $email)
  }
`;

export {UPDATE_EMAIL};
